<template>

  <div id="login">
    
    <div class="left">
      <img src="../../assets/icon/login.png" alt />
    </div>
    <div class="right">
      <div class="right-content">
        <img src="../../assets/icon/qrc.png" alt />
        <div class="main">
          <h1>注册账号</h1>
          <div class="phone">
            <!-- <span class="district">中国+86</span>
            -->
            <span>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
            <input type="text" v-model="phoneNumber" placeholder="请输入手机号" />
          </div>
          <div class="code">
            <input ref="code" v-model="imgToken" type="text" placeholder="请输入图形验证码" />
            <img @click="changeImg" class="imageCaptchaUrl" :src="imageCaptchaUrl" alt />
          </div>
          <div class="code">
            <input ref="code" v-model="phoneCode" id="code" type="text" placeholder="请填写6位短信验证码" />
            <a href="javascript:;" class="text" @click="loginTo">获取短信验证码</a>
          </div>
          <div class="password">
            <input
              ref="password"
              v-model="pass"
              id="password"
              auto-complete="new-password"
              type="password"
              placeholder="8-20位字符，以字母开头"
            />
            <img
              v-if="isok"
              style="width: 19px;height: 11px"
              @click="isshow"
              :src="passwordImg"
              alt
            />
            <img
              v-if="!isok"
              style="width: 19px;height: 11px"
              @click="isshow"
              :src="passwordImg2"
              alt
            />
          </div>
          <div class="password">
            <input
              ref="password2"
              v-model="passWord"
              id="password"
              type="password"
              auto-complete="new-password"
              placeholder="请再次输入密码"
            />
            <img
              v-if="isok2"
              style="width: 19px;height: 11px"
              @click="isshow2"
              :src="passwordImg"
              alt
            />
            <img
              v-if="!isok2"
              style="width: 19px;height: 11px"
              @click="isshow2"
              :src="passwordImg2"
              alt
            />
          </div>

          <el-button
            type="primary"
            style="margin-top:30px;"
            @click="login"
            :disabled="successButton"
          >确定注册</el-button>
          <div class="main-bottom margin-50">
            <el-checkbox v-model="check">
              <span class="text">已阅读同意</span>
              <a href="javascript:;">《用户使用协议》</a>
              <span class="toto">
                <router-link to="/">已有账号，立即登录</router-link>
              </span>
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "../../assets/request";
export function getShopInfo(param = {}, resParams) {
  return 
     
    // .post("qrcapi/Login_loginOut", {
    //   params: {
    //     userId: "334606",
    //     sessionId: "2D2A936D6A4A4B3FF72A26792433E84D"
    //   }
    // })
    // .then(function(response) {
    //   console.log(response);
    //   if (response.data.code == 1) {
    //     that.$message({
    //       type: "success",
    //       message: response.data.msg
    //     });
    //     that.dialogVisible = false;
    //     that.$router.push("/");
    //   } else {
    //     alert(response.data.msg);
    //   }
    // })
    // .catch(function(error) {
    //   alert("网络错误，不能访问");
    //   console.log(error);
    // });
}
export default {
  name: "login",
  data() {
    return {
      check: true, //阅读同意
      successButton: true, //确认按钮
      phoneCode: "", //短信验证码
      pass: "", //第一次密码
      passWord: "", //重复密码
      imgToken: "", //用户输入的图形验证码
      phoneNumber: "", //输入手机号
      successphoneNumber: "", //上一次发送验证码的手机号
      imageCaptchaUrl: "", //验证图片
      imageCaptchaToken: "", //图片验证令牌
      passwordImg: require("../../assets/icon/bxsmm.png"),
      passwordImg2: require("../../assets/icon/xsmm.png"),
      isok: true, //控制密码的显隐
      isok2: true, //控制密码的显隐
      //国家首号下拉列表
      options: [
        {
          value: "选项1",
          label: "中国+86"
        },
        {
          value: "选项2",
          label: "美国+32"
        },
        {
          value: "选项3",
          label: "英国+43"
        },
        {
          value: "选项4",
          label: "日本+69"
        },
        {
          value: "选项5",
          label: "新加坡+52"
        }
      ],
      value: "中国+86"
    };
  },
  methods: {
    //点击验证码
    changeImg() {
      this.reqImg();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    isshow: function() {
      this.isok = !this.isok;
      if (this.isok) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
    },
    isshow2: function() {
      this.isok2 = !this.isok2;
      if (this.isok2) {
        this.$refs.password2.type = "password";
      } else {
        this.$refs.password2.type = "text";
      }
    },
    //发送短信验证码
    loginTo(e) {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.phoneNumber == "") {
        alert("请输入手机号码");
      } else if (!reg.test(this.phoneNumber)) {
        alert("手机格式不正确");
      } else {
        that.successphoneNumber = this.phoneNumber;
        console.log(this.phoneNumber,this.imageCaptchaToken,this.imgToken)
        // console.log(getShopInfo(,'res'))
            this.request
          .post("qrcapi/Login_registCaptcha", {
              userName: this.phoneNumber,
              imageCaptchaToken: this.imageCaptchaToken,
              imageCaptchaCode: this.imgToken
            })
          .then(response=> {
            
               console.log(response)
            if (response.code == 1) {
              this.$message({
                type:'success',
                message:response.msg
              });
            } else {
                 this.reqImg();
              this.$message.error(response.msg)

            }
            console.log(response);
          })
          .catch(function(error) {
            alert("网络错误，不能访问");
            console.log(error);
          });
       
      }
    },
    //注册
    login() {
      var that = this;
      console.log(
        this.phoneCode,
        this.passWord,
        this.successphoneNumber,
        "注册"
      );
      this.axios
        .get(this.url + "qrcapi/Login_regist", {
          params: {
            userName: this.successphoneNumber,
            passWord: this.passWord,
            captcha: this.phoneCode
          }
        })
        .then(function(response) {
             that.reqImg();
          if (response.data.code == 1) {
           that.$message({
              message: response.msg,
              type: "success"
            });
            that.$router.push("/");
          } else {
            alert(response.data.msg);
         
          }
          console.log(response);
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    }
  },
  watch: {
    //两次密码验证
    'pass': function() {
      var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;
      // var phoneNumber = this.phoneNumber
      var pass = this.pass;
      var passWord = this.passWord;
      var imgToken = this.imgToken;
      var phoneCode = this.phoneCode;
      if (reg.test(pass) && passWord === pass&&this.check) {
        console.log("11");
        this.successButton = false;
      } else {
        this.successButton = true;
        console.log("2");
      }
    },
    //两次密码验证
    'passWord': function() {
      var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;
      // var phoneNumber = this.phoneNumber
      var pass = this.pass;
      var passWord = this.passWord;
      var imgToken = this.imgToken;
      var phoneCode = this.phoneCode;
      if (reg.test(pass) && passWord === pass&&this.check) {
        console.log("11");
        this.successButton = false;
      } else {
        this.successButton = true;
        console.log("2");
      }
    },
    'check': function() {
      var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;
      // var phoneNumber = this.phoneNumber
      var pass = this.pass;
      var passWord = this.passWord;
      var imgToken = this.imgToken;
      var phoneCode = this.phoneCode;
      if (reg.test(pass) && passWord === pass&&this.check) {
        console.log("11");
        this.successButton = false;
      } else {
        this.successButton = true;
        console.log("2");
      }
    }
  },
  created() {
    this.reqImg(); //获取图片验证码
  }
};
</script>
<style scoped>
.imageCaptchaUrl {
  position: absolute;
  height: 30px;
  width: 85px;
  right: 0;
  top: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/page/register.vue